import { Component, OnInit, AfterViewInit, NgZone, Input, ChangeDetectorRef } from '@angular/core';
import { ControlContainer, FormGroup, AbstractControl, ValidatorFn, Validators, ValidationErrors } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { first } from 'rxjs/operators';
import { clone, find } from 'lodash';

import { AppState } from '../../app-reducer';
import { QuestionService } from '../../services/question.service';
import { ProcessorService } from '../../services/processor.service';

@Component({
  selector: 'percentage-table',
  templateUrl: './percentage-table.component.html',
  styles: ['.mat-cell {text-align: left}']
})
export class PercentageTableComponent implements OnInit, AfterViewInit {
  @Input() parent: FormGroup;
  @Input() childQuestions: any;
  @Input() isEditable: boolean;
  @Input() isRequired: boolean;
  blockIndex: number = 1;
  addends = new MatTableDataSource([]);
  displayedColumns: string[] = ['allocees', 'percentages'];
  totalAllocation: any = 0;
  isPercent: boolean;
  maxLength: any;
  mask: any;
  IULvalid: boolean = null;
  IULOverShot: boolean = false;
  tableHeader: string | number;
  dollarTotal: any;
  fromAccount: string = 'Account';
  appState$: Observable<any>;
  questions: any;
  IULProceedsAllocFromOpts: any
  public percentTableForm: FormGroup;
  public controls = {};
  parentFormGroup: FormGroup;
  totalControl: AbstractControl;

  constructor(
    private controlContainer: ControlContainer,
    public route: ActivatedRoute,
    private qs: QuestionService,
    private processorService: ProcessorService,
    private store: Store<AppState>,
    private zone: NgZone,
    private cdr: ChangeDetectorRef
  ) {
    this.appState$ = this.store.select('sections');
    const sectionData = this.route.snapshot.data.blockName;
    // get questions from state
    this.appState$.pipe(
      first()
    ).subscribe((state: any) => {
      if (state.questions) {
        this.questions = find(state.questions, { Name: sectionData }).Questions;
      }
    });
    this.IULProceedsAllocFromOpts = find(this.questions, { QuestionName: 'IULProceedsAllocFrom' }).QuestionOptions;
  }

  ngOnInit() {

    this.tableHeader = this.controlContainer.name;
    this.isPercent = this.controlContainer.name === 'IULFixedAcctAlloc' ||
                     this.controlContainer.name === 'IULPremPaymentAllocation' ||
                     this.controlContainer.name === 'IULProceedsAllocToCompound';
    this.percentTableForm = <FormGroup>this.controlContainer.control;
    this.parentFormGroup = <FormGroup>this.parent;
    this.maxLength = this.isPercent ? '3' : null;
    this.mask = this.isPercent ? this.qs.activateMasks('mask-integer') : this.qs.activateMasks('mask-currency-no-symbol');

    this.totalControl = this.isPercent ? this.percentTableForm.controls['PercentTotal'] : this.percentTableForm.controls['DollarTotal'];

    // Analyze conditionality of table inputs
    for(let i = this.childQuestions.length - 1;i >= 0;i--) {
      const q = this.childQuestions[i];
      if (this.checkHidden(q)) {
        this.childQuestions.splice(this.childQuestions.indexOf(q), 1);
        this.percentTableForm.controls[q.QuestionName].clearValidators();
      }
    }

    this.addends.data = this.childQuestions;
    
    this.isEditable = this.isEditable == null ? true : this.isEditable;
    if (!this.isEditable) {
      this.blockIndex = -1;
    }

    this.setPercentageValidation();

    this.setFromAccount();

  }
  //check if hidden or text (not form control)
  checkHidden(q){
    if((q.ConditionalClause && !this.processorService.showConditionalQuestion(q, this.questions, this.percentTableForm.value)) || q.controlType === 'textarea'){
      return true;
    }
    return false;
  }

  setPercentageValidation(){
    if (this.isPercent) {
      this.totalControl.setValidators([Validators.min(100), Validators.max(100)]);
    }
  }
  
  setFromAccount(){
    if (this.tableHeader === 'IULProceedsAllocToCompound') {
      this.controlContainer.control.parent.controls['IULProceedsAllocFrom'].valueChanges.subscribe(from => {
        this.fromAccount = find(this.IULProceedsAllocFromOpts, { key: from }) ? find(this.IULProceedsAllocFromOpts, { key: from }).value : 'Account';
      })
    }
  }

  ngAfterViewInit() {

    window["setTimeout"](() => {
      this.getTotal();
    }, 750);

  }
  
  // Custom validator for DollarTotal === IULMonthlyAutoTransferAmt
  sumsMatch(target: number): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const val = control.value ? +control.value.replace(/[\D]/gm, '') : null;
      if (!val || val !== target) {
        return {notMatchMonthlyTransfer: true};
      }
      return null;      
    }
  }

  getTotal() {

    const oldIULvalid = clone(this.IULvalid);

    this.totalControl.patchValue(0);
    this.totalAllocation = 0;
    for (let i = 0; i < this.addends.data.length; i++) {
      let val = this.percentTableForm.value[this.addends.data[i].QuestionName];
      if (typeof val === 'string') {
        val = val.replace(/[\D]/gm, '');
      }
      if (!isNaN(+val)) {
        this.totalAllocation += +val;
      }
    };

    this.totalControl.patchValue(this.totalAllocation.toString());

    this.IULvalid = this.isPercent ? this.totalAllocation == '100' : this.totalAllocation == this.dollarTotal;
    this.IULOverShot = this.isPercent ? +this.totalAllocation > 100 : +this.totalAllocation > +this.dollarTotal;

    if (this.IULvalid) {
      this.addends.data.forEach(q => {
        if (this.percentTableForm.value[q.QuestionName] == null || this.percentTableForm.value[q.QuestionName] == '') {
          this.percentTableForm.controls[q.QuestionName].patchValue('0');
        }
      });
      this.cdr.detectChanges();
    } else if (oldIULvalid) {
      this.cdr.detectChanges();
    }
    
  }

}
